/*
 * @Author: zhouwei
 * @Date: 2019-10-18 13:58:32
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-04-07 17:43:34
 * @Desc: 统计数据/行为标签
*/
<template>
  <div class="be-tag">
    <div class="myCensusData-detail">
      <div class="myCensusData-title">
        <i></i>
        <span>行为标签概览</span>
      </div>
      <div class="myCensusData-detail-overview">
        <div>
          <div v-if="beTagOverviewT && beTagOverviewT.length > 0">
            <div
              v-for="(item,index) in beTagOverviewT"
              :key="index"
            >
              <mk-pie
                v-if="item.allData !== 0"
                :data="item.data"
                :options="item.options"
                :tooltip="tooltip"
                class="mk-pie first"
              ></mk-pie>
              <div
                v-else
                class="no-data"
              >
                <div class="no-data-img">
                  <img
                    src="@/assets/images/no-data.png"
                    class="img"
                  >
                </div>
                <div class="no-data-txt">
                  暂无数据
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="no-data"
          >
            <div class="no-data-img">
              <img
                src="@/assets/images/no-data.png"
                class="img"
              >
            </div>
            <div class="no-data-txt">
              暂无数据
            </div>
          </div>
        </div>
        <div>
          <div v-if="beTagOverviewT && beTagOverviewA.length > 0">
            <div
              v-for="(item,index) in beTagOverviewA"
              :key="index"
            >
              <mk-pie
                v-if="item.allData !== 0"
                :data="item.data"
                :options="item.options"
                :tooltip="tooltip"
                class="mk-pie"
              ></mk-pie>
              <div
                v-else
                class="no-data"
              >
                <div class="no-data-img">
                  <img
                    src="@/assets/images/no-data.png"
                    class="img"
                  >
                </div>
                <div class="no-data-txt">
                  暂无数据
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="no-data"
          >
            <div class="no-data-img">
              <img
                src="@/assets/images/no-data.png"
                class="img"
              >
            </div>
            <div class="no-data-txt">
              暂无数据
            </div>
          </div>
        </div>
      </div>
      <div class="myCensusData-title">
        <i></i>
        <span>行为标签标记明细</span>
      </div>
      <div v-if="beTagsDetail && beTagsDetail.length > 0">
        <div
          v-for="(item,index) in beTagsDetail"
          :key="index"
        >
          <div class="title">
            {{ index + 1 }}. 分享了{{ item.type }} 《{{ item.title }}》
          </div>
          <mk-bar
            v-if="item.options && item.options.length > 0"
            :data="item.options"
            class="mk-bar"
          >
          </mk-bar>
          <div
            v-else
            class="no-data"
          >
            <div class="no-data-img">
              <img
                src="@/assets/images/no-data.png"
                class="img"
              >
            </div>
            <div class="no-data-txt">
              暂无数据
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="no-data"
      >
        <div class="no-data-img">
          <img
            src="@/assets/images/no-data.png"
            class="img"
          >
        </div>
        <div class="no-data-txt">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    taskList: {
      type: [Array, Object],
      default () {
        return []
      }
    }
  },
  data () {
    return {
      beTagOverviewT: [], // 行为标签概览标签
      beTagOverviewA: [], // 行为标签概览资料
      beTagsDetail: [], // 行为标签明细
      tooltip: [
        'item*percent*count',
        (item, percent, count) => {
          percent = (percent * 100).toFixed(2) + '%'
          return {
            name: item,
            value: '数量:' + count + ',占比:' + percent
          }
        }
      ]
    }
  },
  created () {
    this.scensusBeTagOverview()
    this.getData()
  },
  methods: {
    async scensusBeTagOverview (title, type) {
      // 行为标签概览
      const res = await BIZAPIS.StatisticsApi.timingPlanActionTagOverviewGet({
        planID: this.$route.query.id
      })
      if (res.success) {
        if (res.data.tagDivision && res.data.tagDivision.length > 0) {
          let data = res.data.tagDivision
          let options = []
          data.forEach((item, index) => {
            options[index] = {
              item: item.tag.name,
              count: item.total
            }
          })
          let obj = {
            data: options,
            allData: res.data.totalTagTimes,
            options: {
              chart: {
                width: 600,
                height: 600,
                padding: ['25%', '35%']
              },
              coord: {
                innerRadius: 0.8
              },
              html: {
                text: '给线索打标签',
                subtext: res.data.totalTagTimes,
                unit: '次'
              },
              max: 10
            }
          }
          this.beTagOverviewT = [obj]
        }
        if (res.data.materialDivision && res.data.materialDivision.length > 0) {
          let data = res.data.materialDivision
          let options = []
          data.forEach((item, index) => {
            options[index] = {
              item: item.Title + '资料',
              count: item.Total
            }
          })
          let obj = {
            data: options,
            allData: res.data.totalTagTimes,
            options: {
              chart: {
                width: 600,
                height: 600,
                padding: ['25%', '35%']
              },
              coord: {
                innerRadius: 0.8
              },
              html: {
                text: '给线索打标签',
                subtext: res.data.totalTagTimes,
                unit: '次'
              },
              max: 10
            }
          }
          this.beTagOverviewA = [obj]
        }
      }
    },
    getData () {
      if (this.taskList instanceof Array) {
        this.taskList.forEach((item, index) => {
          let id = item._id
          let title = item.showName
          let type = item.materialType
          let status = Number(item.status)
          let typeTxt = ''
          if (type === 'article') {
            typeTxt = '文章'
          } else if (type === 'form') {
            typeTxt = '表单'
          } else if (type === 'friend') {
            typeTxt = '朋友圈'
          }
          this.scensusBeTagDetail(id, title, typeTxt)
        })
      }
    },
    async scensusBeTagDetail (taskId, title, type) {
      // 行为标签标记明细
      const res = await BIZAPIS.StatisticsApi.timingPlanActionTagStatisticsGet({
        planID: this.$route.query.id,
        taskID: taskId
      })
      if (res.success) {
        let data = res.data.data
        let arr = []
        if (data instanceof Array) {
          data.forEach((item, index) => {
            arr[index] = {
              country: item.tag.name,
              year: new Date(item.day).getTime(),
              value: item.attachCount
            }
          })
          this.beTagsDetail.push({
            title: title,
            type: type,
            options: arr
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.be-tag {
  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding-bottom: 100px;
    padding: 50px 0;

    .no-data-img {
      width: 80px;
      height: 59px;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .no-data-txt {
      font-size: 14px;
      margin-top: 12px;
      color: #bfbfbf;
    }
  }

  .myCensusData-detail {
    margin-top: 32px;

    .myCensusData-title {
      display: flex;
      align-items: center;

      i {
        display: block;
        width: 4px;
        height: 16px;
        background-color: #009cff;
        border-radius: 1px;
        margin-right: 8px;
      }

      span {
        font-size: 13px;
        line-height: 13px;
        color: #262626;
        font-weight: 500;
      }
    }

    .title {
      font-size: 13px;
      line-height: 18px;
      color: #595959;
      margin-top: 28px;
    }

    .myCensusData-detail-overview {
      width: 900px;
      display: flex;
      justify-content: space-around;
    }

    .myCensusData-item {
      .txt {
        margin-left: 64px;
        margin-bottom: 8px;
      }
    }

    .myCensusData-item-title {
      font-weight: 500;
      margin-bottom: 16px;
    }
  }

  .mk-pie {
    margin-top: -125px;
  }

  .mk-pie.first {
    margin-left: 240px;
  }

  .mk-bar {
    margin-top: 28px;
    color: #595959;
  }
}
</style>
